import { useCallback, useRef } from 'react';

/**
 * Custom hook to debounce any function call.
 * @param {Function} func - Function to debounce
 * @param {number} delay - Delay in milliseconds
 * @returns {Function} - Debounced function
 */
const useDebounce = (func, delay) => {
  const timeoutRef = useRef();

  const debouncedFn = useCallback((...args) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      func(...args);
    }, delay);
  }, [func, delay]);

  return debouncedFn;
};

export default useDebounce;
